export default "__VITE_ASSET__BS0qoCra__"